import axios from 'axios';

const URL_API_TWISTERREST = process.env.VUE_APP_SERVICES_DOMAIN + '/twister-rest/api/';

export class TwisterRestApiService {
  getEventosTienda(id_uid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("tokenOauth")}
    };
    const url = `${URL_API_TWISTERREST}eventos/tienda/${id_uid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  getEventosPremium(id_mdt, is_futuro) {
    let config = {
      headers: {'Authorization': localStorage.getItem("tokenOauth")}
    };
    const url = `${URL_API_TWISTERREST}eventos/premium/${id_mdt}/${is_futuro}`
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  getEventosTarifaTienda(id_mdt, id_uid, is_futuro) {
    let config = {
      headers: {'Authorization': localStorage.getItem("tokenOauth")}
    };
    const url = `${URL_API_TWISTERREST}eventos/tarifa/${id_mdt}/tienda/${id_uid}/${is_futuro}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  getModelosTarifa() {
    let config = {
      headers: {'Authorization': localStorage.getItem("tokenOauth")}
    };
    const url = `${URL_API_TWISTERREST}modelo_tarifario/`
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
}